import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  icon: '📸',
  title: 'Snap a photo of your pet',
  description: "Take a picture of your furry friend or choose one from your camera roll. We'll use it to create your unique companion.",
  color: 'bg-coral/20',
  textColor: 'text-coral'
}, {
  number: '02',
  icon: '✨',
  title: 'Watch them come to life',
  description: 'Your pet transforms into a cute, animated digital buddy that lives right on your home screen.',
  color: 'bg-lavender/20',
  textColor: 'text-lavender'
}, {
  number: '03',
  icon: '💛',
  title: 'Build habits together',
  description: 'Complete your daily self-care routines to keep your pet happy, healthy, and thriving.',
  color: 'bg-sage/20',
  textColor: 'text-sage'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-white relative" data-id="element-109">
      <div className="max-w-7xl mx-auto px-6" data-id="element-110">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-111">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black text-warmBrown mb-6" data-id="element-112">
            How it works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-warmBrown/70" data-id="element-113">
            Three simple steps to start your self-care journey with your best
            friend.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-114">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} whileHover={{
          y: -10
        }} className="bg-cream rounded-3xl p-8 relative overflow-hidden group" data-id="element-115">
              <div className={`absolute -right-4 -top-4 w-24 h-24 rounded-full ${step.color} blur-2xl opacity-50 group-hover:opacity-100 transition-opacity`} data-id="element-116" />

              <div className="relative z-10" data-id="element-117">
                <span className={`text-6xl font-black opacity-20 ${step.textColor} absolute -top-4 -left-2`} data-id="element-118">
                  {step.number}
                </span>

                <div className="mt-8 mb-6" data-id="element-119">
                  <div className={`w-16 h-16 rounded-2xl ${step.color} flex items-center justify-center text-3xl shadow-sm`} data-id="element-120">
                    {step.icon}
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-warmBrown mb-4" data-id="element-121">
                  {step.title}
                </h3>
                <p className="text-warmBrown/70 leading-relaxed" data-id="element-122">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}